import styled, { css } from "styled-components";
import getResponsiveBackgroundImageStyles from "../../../helpers/getResponsiveBackgroundImageStyles";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space, { spaceFactor } from "../../../utils/space";
import unit from "../../../utils/unit";
import { cssTextAtm } from "../../atoms/TextAtm/TextAtm.styled";
import GridOrg from "../../organisms/GridOrg";
import PushOrg from "../../organisms/PushOrg";
import RichTextMol from "../RichTextMol";
import { darkModeBackground, footerBackground, mainBackground, promoBoxColor, promoTextVerticalPaddingSpace } from "./PackageBoxSlimMol.settings";
var borderRadius = "xlarge";
var horizontalPaddingSpace = {
  small: 2.5,
  "default": 4
};
export var GridWrapper = styled.div.withConfig({
  componentId: "sc-1o6ok7s-0"
})(function (_ref) {
  var $isGridMode = _ref.$isGridMode;
  return css(["", ""], $isGridMode && css(["display:grid;grid-template-rows:subgrid;grid-row:span 10;"]));
});
export var Wrapper = styled.div.withConfig({
  componentId: "sc-1o6ok7s-1"
})(function (_ref2) {
  var $isGridMode = _ref2.$isGridMode,
    theme = _ref2.theme;
  return css(["display:flex;flex-direction:column;height:100%;border-radius:", ";", ""], getBorderRadius(theme, borderRadius), $isGridMode && css(["display:grid;grid-template-rows:subgrid;grid-row:span 8;"]));
});
export var PromoTextContainer = styled.div.withConfig({
  componentId: "sc-1o6ok7s-2"
})(function (_ref3) {
  var $hasPromoText = _ref3.$hasPromoText,
    theme = _ref3.theme;
  return css(["padding:", " ", ";border-radius:", " ", " 0 0;background:", ";box-shadow:", ";"], space(promoTextVerticalPaddingSpace), space(3), getBorderRadius(theme, borderRadius), getBorderRadius(theme, borderRadius), getColor(theme, promoBoxColor), getBoxShadow(theme, $hasPromoText ? "large" : "nano"));
});
export var Main = styled.div.withConfig({
  componentId: "sc-1o6ok7s-3"
})(function (_ref4) {
  var $hasDarkMode = _ref4.$hasDarkMode,
    $backgroundImage = _ref4.$backgroundImage,
    $isTrialBox = _ref4.$isTrialBox,
    $isGridMode = _ref4.$isGridMode,
    $hasPromoText = _ref4.$hasPromoText,
    $hasExtraParameter = _ref4.$hasExtraParameter,
    theme = _ref4.theme;
  return css(["flex-grow:1;padding:", " ", ";border-radius:", ";background:", ";box-shadow:", ";", " ", " ", " ", " &:not(:last-child){border-bottom-right-radius:0;border-bottom-left-radius:0;}", "{padding-right:", ";padding-left:", ";}"], space(5), space(horizontalPaddingSpace["default"]), getBorderRadius(theme, borderRadius), getColor(theme, $hasDarkMode ? darkModeBackground : mainBackground), getBoxShadow(theme, $hasPromoText ? "large" : "nano"), $isTrialBox && css(["padding:", ";"], space(2)), $isGridMode && css(["display:grid;grid-template-rows:subgrid;grid-row:span 6;", ""], $hasExtraParameter && css(["grid-row:span 8;"])), $backgroundImage && css(["background-repeat:no-repeat;", ""], getResponsiveBackgroundImageStyles($backgroundImage)), $hasPromoText && css(["border-top-left-radius:0;border-top-right-radius:0;"]), breakpoint("small", "medium"), space(horizontalPaddingSpace.small), space(horizontalPaddingSpace.small));
});
export var Label = styled.div.withConfig({
  componentId: "sc-1o6ok7s-4"
})(function () {
  return css(["margin-bottom:", ";"], space(1.5));
});
export var Header = styled.div.withConfig({
  componentId: "sc-1o6ok7s-5"
})(function () {
  return css(["display:flex;flex-direction:column;justify-content:space-between;"]);
});
export var RenewalPayment = styled(RichTextMol).withConfig({
  componentId: "sc-1o6ok7s-6"
})(function (_ref5) {
  var $biggestRenewalPaymentHeight = _ref5.$biggestRenewalPaymentHeight;
  return $biggestRenewalPaymentHeight && css(["min-height:", ";"], unit($biggestRenewalPaymentHeight));
});
export var ParametersGroup = styled(GridOrg).withConfig({
  componentId: "sc-1o6ok7s-7"
})(function (_ref6) {
  var $title = _ref6.$title,
    $hasNoBorder = _ref6.$hasNoBorder,
    $isTrialBox = _ref6.$isTrialBox,
    theme = _ref6.theme;
  var borderWidth = 1;
  var titleTypography = "nano2_u";
  return css(["position:relative;margin-top:", ";padding-top:", ";border-top:", " solid ", ";", " ", " &::before{", " content:\"", "\";position:absolute;top:0;left:0;padding-right:", ";transform:translateY( ", " );background:", ";}"], space($title ? 5 : 2), space($title ? 5 : 4), unit(borderWidth), getBorderColor(theme, mainBackground, "low"), $hasNoBorder && css(["border-top:0;padding-top:0;margin-top:0;grid-gap:", ";"], space(2)), $isTrialBox && css(["height:fit-content;padding:", ";background:", ";border-radius:0 0 ", " ", ";"], space(3), getColor(theme, mainBackground), getBorderRadius(theme, borderRadius), getBorderRadius(theme, borderRadius)), cssTextAtm({
    typography: titleTypography,
    color: "secondary"
  }), $title, space(1), unit((theme.typography[titleTypography].lineHeightSpace * spaceFactor + borderWidth) / -2), getColor(theme, mainBackground));
});
export var ParameterLabelWrapper = styled.div.withConfig({
  componentId: "sc-1o6ok7s-8"
})(function (_ref7) {
  var $hasTooltip = _ref7.$hasTooltip,
    $isTrialBox = _ref7.$isTrialBox,
    theme = _ref7.theme;
  return css(["display:inline;gap:", ";border-bottom:", ";", ""], space(1), $hasTooltip && "".concat(unit(1), " dashed ").concat(getBorderColor(theme, mainBackground, "medium")), $isTrialBox && css(["display:flex;"]));
});
export var ParameterWrapper = styled.div.withConfig({
  componentId: "sc-1o6ok7s-9"
})(function (_ref8) {
  var $isTrialBox = _ref8.$isTrialBox,
    theme = _ref8.theme;
  return css(["gap:", ";position:relative;justify-self:flex-start;&:hover ", "{border-color:", ";}", ""], space(0.5), ParameterLabelWrapper, getBorderColor(theme, mainBackground, "low"), $isTrialBox && css(["display:flex;"]));
});
export var ParameterCta = styled.div.withConfig({
  componentId: "sc-1o6ok7s-10"
})(["flex-shrink:0;margin-left:", ";"], space(2));
export var ParameterLabel = styled(RichTextMol).withConfig({
  componentId: "sc-1o6ok7s-11"
})(["display:inline;"]);
export var ParameterValue = styled(RichTextMol).withConfig({
  componentId: "sc-1o6ok7s-12"
})(["display:inline;&::before{content:\" \";}"]);
export var Footer = styled.div.withConfig({
  componentId: "sc-1o6ok7s-13"
})(function (_ref9) {
  var $hasDarkMode = _ref9.$hasDarkMode,
    $hasPromoText = _ref9.$hasPromoText,
    theme = _ref9.theme;
  return css(["padding:", " ", ";border-radius:0 0 ", " ", ";box-shadow:", ";background:", ";", " ", "{padding-right:", ";padding-left:", ";}"], space(3), space(horizontalPaddingSpace["default"]), getBorderRadius(theme, borderRadius), getBorderRadius(theme, borderRadius), getBoxShadow(theme, $hasPromoText ? "large" : "nano"), getColor(theme, $hasDarkMode ? darkModeBackground : footerBackground), $hasDarkMode && css(["border-top:", " solid ", ";"], unit(1), getColor(theme, "white")), breakpoint("small", "medium"), space(horizontalPaddingSpace.small), space(horizontalPaddingSpace.small));
});
export var ButtonContainer = styled(PushOrg).withConfig({
  componentId: "sc-1o6ok7s-14"
})(function (_ref10) {
  var $isTrialBox = _ref10.$isTrialBox,
    theme = _ref10.theme;
  return css(["margin-top:", ";margin-bottom:", ";", ""], space(4), space(2), $isTrialBox && css(["margin-bottom:0;margin-top:", ";padding:", " ", " 0;background:", ";border-radius:", " ", " 0 0;"], space(1), space(3), space(3), getColor(theme, mainBackground), getBorderRadius(theme, borderRadius), getBorderRadius(theme, borderRadius)));
});
export var TrialContainer = styled.div.withConfig({
  componentId: "sc-1o6ok7s-15"
})(function (_ref11) {
  var theme = _ref11.theme;
  return css(["padding:", ";margin-top:", ";background:", ";border-radius:", ";"], space(3), space(1), getColor(theme, mainBackground), getBorderRadius(theme, borderRadius));
});
export var IconContainer = styled.div.withConfig({
  componentId: "sc-1o6ok7s-16"
})(["flex:none;margin-left:", ";margin-top:", ";"], unit(2), unit(2));